module.exports = __webpack_public_path__ + "static/media/light-green-dot.89a9e888.svg";